import { format } from 'date-fns';
import { useEffect, useState } from "react";
import customerService from "src/services/customerService";

export default function CustomerDetail({ customerId, isOpen, onClose }) {
    const [customerDetail, setCustomerDetail] = useState();

    useEffect(() => {
        customerService.getCustomerDetail(customerId).then((res) => {
            if (res.status == 200) {
                setCustomerDetail(res.data);
            }
        })
    }, [])


    return (

        <div className={`fixed inset-0 ${isOpen ? 'block' : 'hidden'}`}>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="absolute inset-0 flex items-center justify-center">

                <div className="bg-white p-6 rounded-lg shadow-lg max-h-full overflow-y-auto w-96">

                    {customerDetail ? (
                        <div className="flex justify-center">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-96 ">
                                <div className="flex items-center justify-center mb-4 ">
                                    <img
                                        src={customerDetail.image_url || "/assets/images/person.png"}
                                        alt="User Avatar"
                                        className="w-32 h-32 rounded-full border-4 border-blue-500"
                                    />
                                </div>
                                <h2 className="text-2xl font-semibold mb-2">{customerDetail.full_name}</h2>
                                <div className="mb-4 text-gray-600">
                                    <div className="mb-2">
                                        <strong>Email:</strong> {customerDetail.email}
                                    </div>
                                    <div className="mb-2">
                                        <strong>User Type:</strong> {customerDetail.account_type}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Phone:</strong> {customerDetail.phone_number || "No Phone Number"}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Gender:</strong> {customerDetail.gender || "Not Added"}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Address:</strong> {customerDetail.address || "Not Added"}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Date of Birth:</strong> {format(new Date(customerDetail.date_of_birth), 'dd/MM/yyyy')}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Status:</strong> {customerDetail.status || ""}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Joining Date:</strong>  {format(new Date(customerDetail.created_at), 'dd/MM/yyyy')}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Last Updated:</strong>  {format(new Date(customerDetail.updated_at), 'dd/MM/yyyy')}
                                    </div>
                                    {/* <div className="flex flex-col items-center justify-center mb-4">
                                <div className="mb-2">
                                    <strong>Is Phone Verified</strong>
                                </div>
                                {customerDetail.is_phone_verified == 0 ? (
                                    <div className="text-red-500">
                                        <img
                                            src="/assets/images/delete-button.png"
                                            alt="Not Verified"
                                            className="w-20 h-20 rounded-full border-4 border-red-500"
                                        />
                                        <p className="mt-2">Not Verified</p>
                                    </div>
                                ) : (
                                    <div className="text-green-500">
                                        <img
                                            src="/assets/images/approved.png"
                                            alt="Verified"
                                            className="w-20 h-20 rounded-full border-4 border-blue-500"
                                        />
                                        <p className="mt-2">Verified</p>
                                    </div>
                                )}
                            </div> */}

                                    {/* <div className="flex flex-col items-center justify-center mb-4">
                                        <div className="mb-2">
                                            <strong>Is Email Verified</strong>
                                        </div>
                                        {customerDetail.is_email_verified == 0 ? (
                                            <div className="text-red-500">
                                                <img
                                                    src="/assets/images/delete-button.png"
                                                    alt="Not Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-red-500"
                                                />
                                                <p className="mt-2">Not Verified</p>
                                            </div>
                                        ) : (
                                            <div className="text-green-500">
                                                <img
                                                    src="/assets/images/approved.png"
                                                    alt="Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-blue-500"
                                                />
                                                <p className="mt-2">Verified</p>
                                            </div>
                                        )}
                                    </div> */}
                                    <button
                                onClick={onClose}
                                className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            >
                                Close
                            </button>
                                </div>

                            </div>
                           

                        </div>
                    ) : (
                        <>
                        </>
                    )}

                </div>
            </div>
        </div>
    );
}

// export async function getServerSideProps(context) {
//     const { customerId } = context.query;

//     return {
//         props: {
//             customerId: customerId || null, // Handle the case where id is undefined
//         },
//     };
// }